import { PresenceState } from './presence-state.ts';

export const presenceState = new PresenceState();
